// extracted by mini-css-extract-plugin
module.exports = {"headingLabel":"ComponentLayout__headingLabel__2yUUd"};